import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import { createParameterizedUrl } from "@qlik/qlik/src/lib/util/helpers";

const Cta = ({ data }) => {
    const { ctaLabel, browsingContext } = data ?? {};

    let pageUrl = createParameterizedUrl(data);
    const linkProps = {
        to: pageUrl,
        target: browsingContext === "New Tab" ? "_blank" : "_self",
        rel: "noreferrer",
        className: "btn-secondary-small mt-5.25  highlight-transparent",
    };

    return <Link {...linkProps}>{ctaLabel}</Link>;
};

export default Cta;
